import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

interface IStatusActiveProps {
  status: boolean;
}
export const StatusActive: React.FC<IStatusActiveProps> = ({ status }) => {
  if (status) {
    return (
      <CheckCircleOutlined
        style={{ color: '#32cf5c', fontSize: 20 }}
        title="Ativo"
      />
    );
  }

  return (
    <CloseCircleOutlined
      style={{ color: '#ed4140', fontSize: 20 }}
      title="Inativo"
    />
  );
};
